import { BaseApiClient } from '../BaseApiClient'

export class Typeaheads extends BaseApiClient {
  static async personal (query = null, limit = process.env.VUE_APP_TYPEAHEAD_LIMIT) {
    const params = {
      query,
      limit
    }

    return this.get('application-data/typeaheads/personal', {
      params,
      headers: this.getAuthHeaders()
    }).then(response => response.data && response.data.data ? response.data.data : {})
  }

  static async personalUnit (query, limit = process.env.VUE_APP_TYPEAHEAD_LIMIT) {
    const params = {
      query,
      limit
    }

    return this.get('application-data/typeaheads/personal-unit', {
      params,
      headers: this.getAuthHeaders()
    }).then(response => response.data && response.data.data ? response.data.data : [])
  }

  static async carMark (carType, query, limit = process.env.VUE_APP_TYPEAHEAD_LIMIT) {
    const params = {
      carType,
      limit
    }

    return this.get('application-data/typeaheads/car-mark', {
      params,
      headers: this.getAuthHeaders()
    }).then(response => response.data && response.data.data ? response.data.data : [])
  }

  static async carModel (idCarMark, query, limit = process.env.VUE_APP_TYPEAHEAD_LIMIT) {
    const params = {
      id_car_mark: idCarMark,
      query,
      limit
    }

    return this.get('application-data/typeaheads/car-model', {
      params,
      headers: this.getAuthHeaders()
    }).then(response => response.data && response.data.data ? response.data.data : [])
  }

  static async carColor (query, limit = process.env.VUE_APP_TYPEAHEAD_LIMIT) {
    const params = {
      query,
      limit
    }

    return this.get('application-data/typeaheads/car-color', {
      params,
      headers: this.getAuthHeaders()
    }).then(response => response.data && response.data.data ? response.data.data : [])
  }

  static async carNumber (query, limit = process.env.VUE_APP_TYPEAHEAD_LIMIT) {
    const params = {
      query,
      limit
    }

    return this.get('application-data/typeaheads/car-number', {
      params,
      headers: this.getAuthHeaders()
    }).then(
      response => response.data && response.data.data && response.data.data.transports
        ? response.data.data.transports
        : []
    )
  }
}
